import type { ReactNode } from 'react';
import './Kbd.css';

/** Keyboard-shortcut display, e.g. the J/K/A/R legend on the match review queue. */
export function Kbd({ children }: { children: ReactNode }) {
  return <kbd className="dpr-kbd">{children}</kbd>;
}
